// import { UPLOAD_OPTION_TYPES } from 'constants/general-constants'

import svgIcon from 'assets/icons/svg-icon.svg'
import jsonIcon from 'assets/icons/json-icon.svg'
import pdfIcon from 'assets/icons/pdf-icon.svg'
import otherFileIcon from 'assets/icons/other-file-icon.png'

import React from 'react'
import './FileItemDisplay.scss'
import { utilityService } from 'services/UtilityService'
const FileItemDisplay = ({ type, url, name, selected, onSelect }) => {
  const {
    isJsonFile,
    isPDFFile,
    isSVGFile,
    isJpgJpegFile,
    isPNGFile,
    isOtherFile
  } = utilityService.getFileTypeBooleanFlags(type)
  return (
    <div
      className={`file-item-display lottie-file-display ${selected ? 'selected' : ''}`}
      onClick={onSelect}>
      <div className='icon-area'>
        {isPDFFile && <img src={pdfIcon} className='file-preview' />}
        {isJsonFile && <img src={jsonIcon} className='file-preview' />}
        {isSVGFile && <img src={svgIcon} className='file-preview' />}
        {(isJpgJpegFile || isPNGFile) && <img src={url} className='file-preview image-preview' />}
        {isOtherFile && <img className='file-preview other-file-icon' src={otherFileIcon} />}
      </div>
      <div className='name-area'>
        <p title={name}>{name}</p>
      </div>
    </div>
  )
}

export default FileItemDisplay
